import { useEffect, useState } from 'react';
import AppFrame from './containers/AppFrame/AppFrame';
import Header from './containers/Header/Header';
import Navigation from './components/Navigation/Navigation';
import Footer from './containers/Footer/Footer';
import NotificationBanner from './containers/NotificationBanner/NotificationBanner';
import toggles from './config/toggles';
import UnderConstruction from './components/UnderConstruction/UnderConstruction';
import { records as recordsMock } from './testData/mlbStandings';
import { stats as hittingStatsMock } from './testData/mlbHittingStats';
import { stats as pitchingStatsMock } from './testData/mlbPitchingStats';

import './App.css';
import { getStandings } from './apis/getStandings';
import { getHittingStats } from './apis/getHittingStats';
import { getPitchingStats } from './apis/getPitchingStats';

function App() {
  const [standingsYear, setStandingsYear] = useState('2026');
  const [statsYear, setStatsYear] = useState('2026');
  const [statsTimeframe, setStatsTimeframe] = useState('');
  const [mlbStandingsData, setMLBStandingsData] = useState([]);
  const [mlbHittingStatsData, setMLBHittingStatsData] = useState([]);
  const [mlbPitchingStatsData, setMLBPitchingStatsData] = useState([]);

  // Mount
  useEffect(() => {
    if (toggles.useLiveData) {
      getStandings(standingsYear).then((data) => {
        // console.log(data)
        setMLBStandingsData(data);
      });
      getHittingStats(statsYear, statsTimeframe).then((data) => {
        // console.log(data)
        setMLBHittingStatsData(data);
      });
      getPitchingStats(statsYear, statsTimeframe).then((data) => {
        // console.log(data)
        setMLBPitchingStatsData(data);
      });
    } else {
      setMLBStandingsData(recordsMock);
      setMLBHittingStatsData(hittingStatsMock);
      setMLBPitchingStatsData(pitchingStatsMock);
    }
  }, [standingsYear, statsYear, statsTimeframe])

  // console.log("Play Ball!")

  return (
    <div className="App">
      <header className="App-header">
        <Header />
      </header>
      {!toggles.useLiveData ? <NotificationBanner notifications={[{ message: '***** Heads up, we have live data turned off right now for testing! *****', type: 'warning' }]} /> : null}
      {!toggles.updateMessage ? <NotificationBanner notifications={[{ message: '2026 updates are now live!', type: 'success' }]} /> : null}
      {toggles.constructionBuild ? <UnderConstruction /> :
        <>
          <Navigation />
          <br />
          <AppFrame mlbStandingsData={mlbStandingsData} hittingStats={mlbHittingStatsData} pitchingStats={mlbPitchingStatsData} setYearStatsFn={setStatsYear} setYearStandingsFn={setStandingsYear} setStatsTimeframeFn={setStatsTimeframe} statsTimeFrameSelected={statsTimeframe} standingsYearSelected={standingsYear} statsYearSelected={statsYear} />
        </>
      }
      <Footer />
    </div>
  );
}

export default App;
